<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5.50037H14" stroke="currentColor" stroke-width="1.5"/>
<path d="M2 10.4996H14" stroke="currentColor" stroke-width="1.5"/>
<path d="M8.00024 10.1677C9.19745 10.1677 10.168 9.1972 10.168 8C10.168 6.8028 9.19745 5.83228 8.00024 5.83228C6.80304 5.83228 5.83252 6.8028 5.83252 8C5.83252 9.1972 6.80304 10.1677 8.00024 10.1677Z" fill="currentColor"/>
</svg>
